import { IWidgetOption, IWidgetOptionValue } from '../../../../Widget';

export function isWidgetOptionValue(
  option: IWidgetOption,
): option is IWidgetOptionValue {
  return option.type === 'option';
}
